module.exports = __webpack_public_path__ + "img/pizza.be5030ca.webp";